import axios from 'axios'
import CONFIG from '../config.js'

import takeFirstResult from '@/api/util/takeFirstResult'
import flattenACF from '@/api/util/flattenACF'
import normalizeWordpress from '@/api/util/normalizeWordpress'
import transformWPDateFormat from '@/api/util/transformWPDateFormat'
import transformBlogPost from '@/api/util/transformBlogPost'
import transformFlexContent from '@/api/util/transformFlexContent'
import transformLocalizationInfo from '@/api/util/transformLocalizationInfo'
import transformPostMeta from '@/api/util/transformPostMeta'

export function getBlogPostsList (page = 1) {
	return axios.get(`${CONFIG.API_URL}/wp/v2/posts?per_page=20&page=${page}`)
	.then(response => {
		response.data = transformPostMeta(transformWPDateFormat(flattenACF(normalizeWordpress(response.data))))
		return response
	})
}

export function getBlogPostBySlug (slug) {
	return new Promise((resolve, reject) => {
		axios.get(`${CONFIG.API_URL}/wp/v2/posts?slug=${slug}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				takeFirstResult,
				normalizeWordpress,
				flattenACF,
				transformWPDateFormat,
				transformPostMeta,
				transformBlogPost,
				transformFlexContent
			)
		})
		.then(response => {
			const { data } = response
			// console.log(response)
			;(data && data.id) ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' })
		})
		.catch(response => reject(response))
	})
}

export function getBlogPageData ({ lang = 'de-ch', slug = 'blog' }) {
	return new Promise((resolve, reject) => {
		return axios.get(`${CONFIG.API_URL}/wp/v2/pages?slug=${slug}${lang === 'en-us' ? '&lang=en' : '&lang=de'}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				takeFirstResult,
				normalizeWordpress,
				flattenACF,
				transformPostMeta,
				transformLocalizationInfo
			)
		})
		.then(response => {
			// console.log(response.data)
			const { data } = response
			;(data && data.id) ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' })
		})
		.catch(response => reject(response))
	})
}

export default 'yolo'



// WEBPACK FOOTER //
// ./src/api/blog.wp.api.js